/* eslint-disable func-names */
import { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { CookieConsentModule } from '@/modules';

export default function PendoScriptContainer() {
    function loadPendoScript(apiKey) {
        (function (p, e, n, d, o) {
            const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
            let w; let x;
            // eslint-disable-next-line no-multi-assign
            o = p[d] = p[d] || {};
            o._q = o._q || [];
            for (w = 0, x = v.length; w < x; ++w) {
                (function (m) {
                    o[m] = o[m] || function () {
                        // eslint-disable-next-line prefer-rest-params
                        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                    };
                }(v[w]));
            }
            const y = e.createElement(n);
            y.async = !0;
            y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
            const z = e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y, z);
        }(window, document, 'script', 'pendo'));
        // This function creates visitors and accounts in Pendo
        // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
        // Please use Strings, Numbers, or Bools for value types.
        window.pendo.initialize({
            visitor: {
                id: 'VISITOR-UNIQUE-ID', // This exact string is required to generate the anonymous ID
            },
        });
    }

    const {
        enable_pendo: [isPendoEnabled],
    } = useFeatures([
        'enable_pendo',
    ]);

    const isPendoLoaded = useRef(false);

    const hasSuppressedCookies = useSelector(CookieConsentModule.duck.selectors.selectHasSuppressedGroup);
    useEffect(() => {
        if (!hasSuppressedCookies && isPendoEnabled && !isPendoLoaded.current) {
            loadPendoScript('125e14c6-efdb-45a7-7cc2-3bd0112916b1');
            isPendoLoaded.current = true;
        }
    }, [hasSuppressedCookies, isPendoEnabled]);
}
